import React, {useEffect, useState} from "react";
import {Button, Input, Select, SelectItem} from "@nextui-org/react";
import {useLocation} from "react-router-dom";
import {FaEnvelope, FaFile} from 'react-icons/fa';
import {Categories, createProduct} from "../API";
import {toast, Toaster} from "sonner";
import ImageCropper from "./ImageCropper";

export default function ProductsDetails() {
    const init= {
        name: '',
        description: '',
        idcategory: '1',
        sale_price: 0,
        tax: 0,
        cost: 0,
        barcode: ''
    }
    const [product, setProduct] = useState(init);
    const [image, setImage] = useState('');
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const {data} = location.state || {};

    useEffect(() => {
        Starting();
    }, []);

    async function Starting() {
        if(!!data)
            setProduct(data);

        const c = await Categories();
        setCategories(c);
    }

    function OnChange(e) {
        setProduct({...product, [e.target.name]: e.target.value});
    }

    async function OnSubmit(e) {
        e.preventDefault();
        setLoading(true);
        const formData = new FormData();
        if(!!image)
            formData.append('file', image);
        formData.append('item', JSON.stringify(product));

        const res = await createProduct(formData);

        if (res === 200)
            toast.success("Producto creada correctamente. ✅")
        else
            toast.error("Algo ha salio mal. 🙁")
        setLoading(false);
    }

    return (
        <>
            <Toaster richColors/>
            <h1 className="pb-5 text-2xl">Detalles del producto</h1>
            <h2 className="pb-5 text-xl text-warning">Detalles generales</h2>
            <div className="flex flex-col gap-4">
                <form className="flex w-full flex-wrap gap-4" onSubmit={OnSubmit}>
                    <Input
                        type="text"
                        label="Nombre"
                        name="name"
                        labelPlacement="outside"
                        value={product.name}
                        onChange={OnChange}
                        isRequired
                        required
                    />
                    <Input
                        type="text"
                        label="Descripcion"
                        labelPlacement="outside"
                        name="description"
                        value={product.description}
                        onChange={OnChange}
                        isRequired
                        required
                    />
                    <Input
                        type="text"
                        label="Codigo de barra"
                        labelPlacement="outside"
                        name="barcode"
                        value={product.barcode}
                        onChange={OnChange}
                        isRequired
                        required
                    />
                    <Select
                        label="Categoria"
                        labelPlacement="outside"
                        aria-label="Categoria"
                        onChange={OnChange}

                        name="idcategory"
                        isRequired
                        required
                    >
                        {
                            categories.map((item, index) => (
                                <SelectItem key={item.id}>{item.category}</SelectItem>
                            ))
                        }
                    </Select>
                    <div className="flex flex-col w-full flex-wrap gap-4 pb-5">
                        <ImageCropper setImage={setImage} name={product.name}/>
                    </div>

                    <h2 className="pb-5 text-xl text-warning">Precio</h2>
                    <Input
                        min={1}
                        type="number"
                        label="Costo"
                        labelPlacement="outside"
                        value={product.cost}
                        name="cost"
                        onChange={OnChange}
                        isRequired
                        required
                        startContent={
                            <div className="pointer-events-none flex items-center">
                                <span className="text-default-400 text-small">Gs.</span>
                            </div>
                        }
                    />
                    <Input
                        min={1}
                        type="number"
                        name="sale_price"
                        label="Precio"
                        labelPlacement="outside"
                        value={product.sale_price}
                        onChange={OnChange}
                        isRequired
                        required
                        startContent={
                            <div className="pointer-events-none flex items-center">
                                <span className="text-default-400 text-small">Gs.</span>
                            </div>
                        }
                    />
                    <Input
                        min={1}
                        type="number"
                        label="IVA"
                        name="tax"
                        labelPlacement="outside"
                        value={product.tax}
                        onChange={OnChange}
                        isRequired
                        required
                        startContent={
                            <div className="pointer-events-none flex items-center">
                                <span className="text-default-400 text-small">Gs.</span>
                            </div>
                        }
                    />

                    <div className="container text-center">
                        <Button color="success" type="submit"
                                size="lg"
                                isLoading={loading}>{product.idproduct === undefined ? "Crear" : "Actualizar"}</Button>

                    </div>

                </form>

            </div>
        </>
    );
}
